var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-danger"},[_c('h3',[_vm._v("Erro 404 :(")]),_c('h5',[_vm._v("Você não tem permissão para acessar esta página")]),_c('div',{staticClass:"mt-5 pt-5 text-secondary"},[_c('router-link',{attrs:{"to":_vm.$store.state.menu.filter((x) =>
          x.permissao.includes(_vm.$store.state.auth.user.tipo)
        )[0].link}},[_vm._v("Página Inicial")]),_c('a',{staticClass:"ml-4",attrs:{"href":"/logout"}},[_vm._v("Logout")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }